import Menu from 'antd/es/menu';
import styled from 'styled-components';
import { TMenuItemProps, TMenuProps } from './menu.types';

const { Item } = Menu;
const SMenu = styled(Menu)<TMenuProps>``;

const SMenuItem = styled(Item)<TMenuItemProps>``;
export { SMenu, SMenuItem };
